/* eslint-disable i18next/no-literal-string */
import React, {ReactNode, createContext, useContext} from 'react';

import {assertIsNotNullish} from '@br/idm-components';
import {generatePath} from '@br/mg-components';

import type {UserContextType, UserData} from '../types';
import {safeLoadJson} from '../utils/data';

const getSingleUserNavigation = (userData: UserData): string | undefined => {
    const isSolelySupportUser =
        userData.isSupportUser && userData.partners.length === 0 && userData.tenants.length === 0;
    const isSolelyPartnerUser =
        !userData.isSupportUser && userData.partners.length === 1 && userData.tenants.length === 0;
    const isSolelyTenant = !userData.isSupportUser && userData.partners.length === 0 && userData.tenants.length === 1;
    const isANobody = !userData.isSupportUser && userData.partners.length === 0 && userData.tenants.length === 0;

    /* istanbul ignore next */
    if (isANobody) {
        return '/portal/activate/';
    }
    if (isSolelySupportUser) {
        return '/portal/support/';
    }
    if (isSolelyPartnerUser) {
        return generatePath('/portal/partner/:partnerId/', {partnerId: userData.partners[0].groupId});
    }
    if (isSolelyTenant) {
        return generatePath('/portal/tenant/:tenantId/', {tenantId: userData.tenants[0].tenantId});
    } else {
        return;
    }
};

const UserContext = createContext<UserContextType | null>(null);

/* istanbul ignore next */
const UserContextProvider = ({children}: {children: ReactNode}): JSX.Element => {
    const userData = safeLoadJson<UserData>('#userData');

    if (userData) {
        return (
            <UserContext.Provider value={{...userData, singleUserNavigation: getSingleUserNavigation(userData)}}>
                {children}
            </UserContext.Provider>
        );
    }
    return <>{children}</>;
};

const useUserContext = () => {
    const userContext = useContext(UserContext);
    assertIsNotNullish(userContext);
    return userContext;
};

const useNullableUserContext = () => useContext(UserContext);

export {UserContextProvider, getSingleUserNavigation, useUserContext, useNullableUserContext, UserContext};
